const config = {
  env: 'prod',
  region: 'apac',
  page: '/ocp-dashboard',
  path: 'api/v2/files',
  get baseUrl() {
    return `${this.page}/${this.env}-${this.region}/${this.path}`;
  },
};

export const AZURE_AD_GROUP_DPO_IOT_APPLIANCE_LOG =
  'group:default/dpo-plugin-iot-appliance-log-read';

export const modifyRegionAndEnv = (env: string, region: string) => {
  config.env = env;
  config.region = region;
};

export const CONFIG = config;

export type UserToSubmit = {
  username: string;
  id: string;
  region: string;
  environment: string;
};
